import api from "PFCore/api";
import { Id, Notification } from "PFCore/types";

export const fetchNotification = (id: Id) => api<Notification>({ url: `notifications/${id}` });
